import React, { useState, useEffect, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import api from '../../config/api';
import { completedYears, isTodayMonthDay } from '../../utils/dateUtils';
import styles from './HomePage.module.css';

const HOME_CARDS = [
  {
    label: 'Appraisal',
    desc: 'Fill in and track your performance appraisal form.',
    icon: '📋',
    path: '/appraisal',
  },
  {
    label: 'Code of Conduct',
    desc: 'Review and acknowledge the company code of conduct.',
    icon: '📜',
    path: '/code-of-conduct',
  },
  {
    label: 'Rewards & Recognition',
    desc: 'Nominate and celebrate outstanding peers.',
    icon: '🏆',
    path: '/rnr',
  },
  {
    label: 'Long Service Awards',
    desc: 'Recognition for long-term service milestones.',
    icon: '🎖️',
    path: '/lsa',
    badgeKey: 'anniversaries',
  },
  {
    label: 'HRMS',
    desc: 'Daily attendance — web login and mobile app details.',
    icon: '🏢',
    path: '/hrms',
  },
  {
    label: 'Birthdays',
    desc: 'See whose birthday is coming up this month.',
    icon: '🎂',
    path: '/birthdays',
    badgeKey: 'birthdays',
  },
];

const HomePage = () => {
  const { user } = useAuth();
  const firstName = user?.name?.split(' ')[0];
  const [employees, setEmployees] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const res = await api.getAllEmployees();
        if (res.success) setEmployees(res.data);
      } catch { /* ignore — badges just stay hidden */ }
    })();
  }, []);

  // "Today" counts, shown as small indicator badges — without one, nobody thinks
  // to go check either page.
  const todayCounts = useMemo(() => {
    const active = employees.filter((e) => e.isActive);
    return {
      birthdays: active.filter((e) => e.dateOfBirth && isTodayMonthDay(e.dateOfBirth)).length,
      anniversaries: active.filter((e) => e.dateOfJoining && completedYears(e.dateOfJoining) >= 1 && isTodayMonthDay(e.dateOfJoining)).length,
    };
  }, [employees]);

  return (
    <div className={styles.container}>
      <div className={styles.welcome}>
        <div className={styles.welcomeTitle}>
          {firstName ? `Welcome, ${firstName}` : 'Welcome'}
        </div>
      </div>

      <div className={styles.grid}>
        {HOME_CARDS.map((card) => {
          const badgeCount = card.badgeKey ? todayCounts[card.badgeKey] : 0;
          return (
            <Link key={card.path} to={card.path} className={styles.card}>
              {badgeCount > 0 && <div className={styles.badge}>{badgeCount}</div>}
              <div className={styles.icon}>{card.icon}</div>
              <div className={styles.cardTitle}>{card.label}</div>
              <div className={styles.cardDesc}>{card.desc}</div>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default HomePage;
